<script setup lang="ts">
import { eventBus } from "#bb/lib/eventBus";

const props = defineProps<{ id: string }>();

const { getContentById } = useContentManager();
const definitionData = computed(() => getContentById(props.id));

const features = inject("render-features", { editor: false });

const commands = [
  {
    id: "editors-group",
    type: "group",
    name: "Editors",
    description: "Cover Page editors",
    commands: [
      {
        id: "edit",
        name: "Edit",
        description: "Edit this cover page",
        action: async () => {
          eventBus.emit(`component:onEdit:${props.id}`, {
            data: definitionData.value,
          });
        },
        icon: "lucide:edit",
      },
    ],
  },
];

defineExpose({
  commands,
  properties: {
    id: props.id,
    name: "Cover Page",
    icon: "lucide:book-image",
  },
});
</script>

<template>
  <div
    v-if="features.editor"
    class="inline-flex items-center gap-2 rounded-sm border border-dashed bg-muted/30 px-3 py-2 text-xs text-muted-foreground"
  >
    <Icon mode="svg" size="14" name="lucide:book-image" />
    Cover Page (rendered in PDF export)
  </div>

  <div v-if="features.editor" class="hidden">
    <editor-reports-cover-page :id="props.id" />
  </div>
</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";

export default {
  componentId: ComponentDefinitionIds.COVER_PAGE,
  icon: "lucide:book-image",
  editor: () => import("#bb/components/editor/reports/cover-page.vue"),
  type: "Cover Page",
  description: "Defines the PDF report cover page rendered by the export compiler.",
  default: {
    title: "",
    subtitle: "",
    logo: "",
    backgroundImage: "",
  },
  categories: ["Reports"],
  order: 12010,
};
</script>
